import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { SOCIAL_MEDIA_PLATFORMS } from "@/api/queries/socialMediaPlatforms";
import type { SocialMediaPlatformsQuery } from "@/__generated__/graphql";

export interface SocialMediaPlatform {
  id: string;
  name: string;
  baseUrl: string | null;
  iconUrl: string | null;
}

export const useSocialMediaPlatforms = () => {
  const { data, loading, error } = useQuery<SocialMediaPlatformsQuery>(
    SOCIAL_MEDIA_PLATFORMS,
  );

  const platforms = useMemo(() => {
    if (!data?.socialMediaPlatforms?.nodes) {
      return [];
    }

    return data.socialMediaPlatforms.nodes
      .filter((node): node is NonNullable<typeof node> => node !== null)
      .map((node) => ({
        id: node.id,
        name: node.name,
        baseUrl: node.baseUrl ?? null,
        iconUrl: node.icon?.url ?? null,
      }));
  }, [data]);

  return {
    platforms,
    loading,
    error,
  };
};
